export default __webpack_public_path__ + "13392f0.png";